/* Interactivity for the standalone "Best Running Clubs in America" guide (.nja-guide). */

const API = process.env.REACT_APP_BACKEND_URL;

export function initRunClubGuide(root) {
  const guide = root.querySelector('.nja-guide');
  if (!guide || guide.dataset.init) return;
  guide.dataset.init = '1';

  const $ = (s, c) => (c || guide).querySelector(s);
  const $$ = (s, c) => Array.prototype.slice.call((c || guide).querySelectorAll(s));
  const cards = $$('.nja-card');

  /* toast */
  const toastEl = $('#njaToast');
  let toastT;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('on');
    clearTimeout(toastT);
    toastT = setTimeout(() => toastEl.classList.remove('on'), 3200);
  }

  /* sticky bar */
  const sticky = $('#njaSticky');
  const hero = $('.nja-hero');
  if (sticky && hero && 'IntersectionObserver' in window) {
    new IntersectionObserver((e) => {
      sticky.classList.toggle('on', !e[0].isIntersecting);
    }, { rootMargin: '-80px 0px 0px 0px' }).observe(hero);
  }

  /* youtube facades */
  guide.addEventListener('click', (e) => {
    const btn = e.target.closest('.nja-yt');
    if (!btn || btn.dataset.loaded) return;
    const id = btn.dataset.yt;
    if (!id) return;
    btn.dataset.loaded = '1';
    const f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1';
    f.title = btn.getAttribute('aria-label') || 'YouTube video';
    f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    f.allowFullscreen = true;
    f.loading = 'lazy';
    btn.innerHTML = '';
    btn.appendChild(f);
  });

  /* instagram embeds */
  if ($('.instagram-media')) {
    const s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.instagram.com/embed.js';
    document.body.appendChild(s);
  }

  /* filtering */
  const fSearch = $('#njaSearch');
  const fCity = $('#njaCity');
  const countEl = $('#njaCount');
  const emptyEl = $('#njaEmpty');
  const clearEl = $('#njaClear');
  let activeTags = [];

  function applyFilters() {
    const q = ((fSearch && fSearch.value) || '').trim().toLowerCase();
    const city = (fCity && fCity.value) || '';
    let shown = 0;
    cards.forEach((c) => {
      let ok = true;
      if (q && c.dataset.search.indexOf(q) === -1) ok = false;
      if (ok && city && c.dataset.city !== city) ok = false;
      if (ok && activeTags.length) {
        const t = c.dataset.tags.split(' ');
        for (let i = 0; i < activeTags.length; i++) {
          if (t.indexOf(activeTags[i]) === -1) { ok = false; break; }
        }
      }
      c.hidden = !ok;
      if (ok) shown++;
    });
    $$('.nja-region').forEach((r) => {
      r.hidden = !$$('.nja-card', r).some((c) => !c.hidden);
    });
    const filtering = !!(q || city || activeTags.length);
    if (countEl) {
      countEl.textContent = filtering
        ? shown + (shown === 1 ? ' club matches' : ' clubs match')
        : 'Showing all ' + cards.length + ' clubs';
    }
    if (emptyEl) emptyEl.hidden = shown !== 0;
    if (clearEl) clearEl.hidden = !filtering;
  }

  function clearAll() {
    if (fSearch) fSearch.value = '';
    if (fCity) fCity.value = '';
    activeTags = [];
    $$('.nja-fchip').forEach((b) => b.classList.remove('on'));
    applyFilters();
  }

  if (fSearch) fSearch.addEventListener('input', applyFilters);
  if (fCity) fCity.addEventListener('change', applyFilters);
  $$('.nja-fchip').forEach((b) => {
    b.addEventListener('click', () => {
      const t = b.dataset.tag;
      const i = activeTags.indexOf(t);
      if (i > -1) activeTags.splice(i, 1); else activeTags.push(t);
      b.classList.toggle('on', i === -1);
      applyFilters();
    });
  });
  [$('#njaReset'), clearEl].forEach((b) => {
    if (b) b.addEventListener('click', clearAll);
  });
  applyFilters();

  /* table sort */
  const table = $('#njaTable');
  if (table) {
    const tbody = table.tBodies[0];
    $$('thead th', table).forEach((th, idx) => {
      const btn = th.querySelector('button');
      if (!btn) return;
      btn.addEventListener('click', () => {
        const asc = th.getAttribute('aria-sort') === 'descending';
        $$('thead th', table).forEach((o) => o.removeAttribute('aria-sort'));
        th.setAttribute('aria-sort', asc ? 'ascending' : 'descending');
        const rows = $$('tr', tbody);
        rows.sort((a, b) => {
          const ca = a.cells[idx]; const cb = b.cells[idx];
          const na = ca.dataset.n; const nb = cb.dataset.n;
          let r;
          if (na !== undefined && nb !== undefined) r = parseFloat(na) - parseFloat(nb);
          else r = ca.textContent.trim().localeCompare(cb.textContent.trim());
          return asc ? r : -r;
        });
        rows.forEach((r) => tbody.appendChild(r));
      });
    });
  }

  /* star ratings (per-device, localStorage) */
  const STORE = 'nja_runclub_ratings_v1';
  function getRatings() {
    try { return JSON.parse(localStorage.getItem(STORE) || '{}'); } catch (e) { return {}; }
  }
  function paint(id, v) {
    $$('.nja-star[data-club="' + id + '"]').forEach((s) => {
      s.classList.toggle('on', parseInt(s.dataset.v, 10) <= v);
    });
    const out = $('[data-out="' + id + '"]');
    if (out) out.textContent = 'You rated this ' + v + '/5 · saved on this device';
  }
  const saved = getRatings();
  Object.keys(saved).forEach((id) => paint(id, saved[id]));

  guide.addEventListener('click', (e) => {
    const st = e.target.closest('.nja-star');
    if (!st) return;
    const id = st.dataset.club;
    const v = parseInt(st.dataset.v, 10);
    const all = getRatings();
    all[id] = v;
    try { localStorage.setItem(STORE, JSON.stringify(all)); } catch (err) { /* quota */ }
    paint(id, v);
    toast(v >= 4 ? 'Thanks — glad that one worked out.' : 'Noted. Thanks for the honesty.');
    document.dispatchEvent(new CustomEvent('nja:rating', { detail: { club: id, rating: v } }));
  });

  /* quiz */
  const answers = {};
  const qres = $('#njaQres');
  const qCity = $('#qCity');

  $$('.nja-opt').forEach((b) => {
    b.addEventListener('click', () => {
      const k = b.dataset.q;
      $$('.nja-opt[data-q="' + k + '"]').forEach((o) => o.classList.remove('on'));
      b.classList.add('on');
      answers[k] = b.dataset.v;
      maybeRun();
    });
  });
  if (qCity) qCity.addEventListener('change', () => { answers.city = qCity.value; maybeRun(); });

  function maybeRun() {
    if (answers.city && answers.level && answers.why && answers.when) run();
  }

  function sub(card) {
    const p = (card.dataset.sub || '').split('-').map(Number);
    return { pace: p[0] || 0, nodrop: p[1] || 0, first: p[2] || 0, rel: p[3] || 0,
      etiq: p[4] || 0, cult: p[5] || 0, acc: p[6] || 0, subst: p[7] || 0 };
  }

  function rank(pool) {
    return pool.map((c) => {
      const s = sub(c); const t = c.dataset.tags.split(' ');
      let v = parseInt(c.dataset.score, 10);
      if (answers.level === 'new') {
        v += s.nodrop * 1.5 + s.first * 1.2 + s.pace * 0.6;
        if (t.indexOf('beginner') === -1) v -= 40;
      } else if (answers.level === 'some') {
        v += s.nodrop * 0.7 + s.cult * 0.8 + s.first * 0.5;
      } else {
        v += s.subst * 3 + s.pace * 0.8 + s.rel * 0.8;
      }
      if (answers.why === 'people') v += s.cult * 1.6 + s.first * 1.1;
      else if (answers.why === 'train') v += s.subst * 2.4 + s.pace * 1.0;
      else v += s.rel * 2.2 + s.nodrop * 0.9;
      if (answers.when !== 'any' && t.indexOf(answers.when) === -1) v -= 22;
      return { el: c, v };
    }).sort((a, b) => b.v - a.v);
  }

  function qcard(r, i, tail) {
    const el = r.el;
    const name = el.querySelector('h3').textContent;
    const loc = el.querySelector('.nja-loc').textContent;
    const meets = el.dataset.meets || '';
    return '<a class="nja-qcard" href="#' + el.id + '"><i>' + (i + 1) + '</i><span><b>' +
      esc(name) + (tail ? ' <em class="nja-qtag">' + tail + '</em>' : '') + '</b><span>' +
      esc(loc) + (meets ? ' &middot; ' + esc(meets) : '') + '</span></span></a>';
  }

  function run() {
    const cityUsed = answers.city && answers.city !== '__any';
    const inCity = cityUsed ? cards.filter((c) => c.dataset.city === answers.city) : [];
    const local = rank(inCity).slice(0, 3);
    const need = 3 - local.length;
    const fill = need > 0
      ? rank(cards.filter((c) => inCity.indexOf(c) === -1)).slice(0, need)
      : [];

    const why = {
      new: 'clubs with a walk or short option and a real no-drop policy',
      some: 'clubs that welcome a steady three-miler without dropping them',
      lots: 'clubs with genuine training substance, not just a social lap',
    }[answers.level];

    let head; let list;
    if (!cityUsed) {
      head = '<h3>Your top three</h3><p>Ranked nationwide for ' + why + '.</p>';
      list = rank(cards).slice(0, 3).map((r, i) => qcard(r, i, '')).join('');
    } else if (local.length === 0) {
      head = "<h3>We don't cover " + esc(answers.city) + ' yet</h3><p>Here are the three strongest clubs ' +
        'in the country instead — and if you email us, ' + esc(answers.city) + ' goes to the top of the list ' +
        'for the next update.</p>';
      list = fill.map((r, i) => qcard(r, i, '')).join('');
    } else {
      const word = local.length === 1 ? 'pick' : (local.length === 2 ? 'two picks' : 'top three');
      head = '<h3>Your ' + (local.length === 1 ? 'top pick' : word) + ' in ' + esc(answers.city) + '</h3>' +
        '<p>Ranked for ' + why + '.' +
        (need > 0 ? ' ' + esc(answers.city) + ' only has ' + local.length +
          (local.length === 1 ? ' club' : ' clubs') + " in this guide, so we've added the best of the rest of the country below."
          : '') + '</p>';
      list = local.map((r, i) => qcard(r, i, '')).join('') +
        fill.map((r, i) => qcard(r, local.length + i, 'elsewhere')).join('');
    }

    qres.innerHTML = head + '<div class="nja-qcards">' + list + '</div>' +
      '<p class="nja-qwhy">Scored on pace honesty, no-drop mechanics and first-timer experience — see the ' +
      'full breakdown on each club card below.</p>';
    qres.hidden = false;

    if (fCity && cityUsed && local.length) { fCity.value = answers.city; applyFilters(); }
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
    }[c]));
  }

  /* email capture → NinjAthlete leads system (Run Club Checklist magnet) */
  $$('.nja-form').forEach((f) => {
    f.addEventListener('submit', (e) => {
      e.preventDefault();
      const input = f.querySelector('input[type=email]');
      const email = (input.value || '').trim();
      if (!email || email.indexOf('@') < 1) { input.focus(); return; }
      const btn = f.querySelector('button[type=submit]');
      if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
      fetch(API + '/api/leads/dojo', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, magnet_id: 'runclub_checklist', source: f.dataset.form || 'runclub-guide' }),
      }).then((r) => {
        if (!r.ok) throw new Error('subscribe failed');
        document.dispatchEvent(new CustomEvent('nja:subscribe', { detail: { email, source: f.dataset.form || 'runclub-guide' } }));
        f.classList.add('done');
        const note = f.querySelector('.nja-form-note');
        if (note) note.innerHTML = "<strong style='color:#d7ff3e'>Check your inbox.</strong> The checklist is on its way to " + esc(email) + '.';
        toast("You're on the list.");
      }).catch(() => {
        if (btn) { btn.disabled = false; btn.textContent = 'Send it to me'; }
        toast('Something went wrong — please try again.');
      });
    });
  });

  /* club submissions — posts to the research queue (mailto fallback if API is down) */
  const sform = $('#njaSubmitForm');
  if (sform) {
    sform.addEventListener('submit', (e) => {
      e.preventDefault();
      const f = {};
      $$('input, textarea', sform).forEach((i) => { f[i.name] = (i.value || '').trim(); });
      if (!f.club || !f.city || !f.email) return;

      const btn = sform.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = 'Submitting…'; }

      fetch(API + '/api/runclubs/submissions', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(f),
      }).then((r) => {
        if (!r.ok) throw new Error('submit failed');
        document.dispatchEvent(new CustomEvent('nja:clubsubmit', { detail: f }));
        sform.classList.add('done');
        const note = sform.querySelector('.nja-sform-note');
        if (note) {
          note.className = 'nja-sform-done';
          note.innerHTML = '<strong>Got it — ' + esc(f.club) + ' is in the research queue.</strong> ' +
            'We read every submission, score it on the same eight criteria as everyone else, and email you when the score goes live.';
        }
        toast("Thanks — we'll go research it.");
      }).catch(() => {
        if (btn) { btn.disabled = false; btn.textContent = 'Submit your club'; }
        const body = [
          'Club name: ' + f.club,
          'City: ' + f.city,
          'Instagram: ' + (f.ig || '—'),
          'Meets: ' + (f.when || '—'),
          'Submitted by: ' + f.email,
        ].join('\n');
        window.location.href = 'mailto:info@ninjathlete.com' +
          '?subject=' + encodeURIComponent('Run club submission: ' + f.club + ' (' + f.city + ')') +
          '&body=' + encodeURIComponent(body);
        toast('Could not reach the server — opened your email app instead.');
      });
    });
  }
}
